import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import useBookDemoButton from "./BookDemoButton.hooks";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";
import { useTranslation } from "../../../localization/useTranslation";

export interface IBookDemoButtonProps {
    showWithFreePlan: boolean;
    buttonType: "green" | "secondary";
    width: number;
}

function BookDemoButton(props: IBookDemoButtonProps) {
    const { hasPaidPlan, isLoading } = useBookDemoButton();
    const { language } = useUserContext();
    const { translateString } = useTranslation();

    const shouldShow = props.showWithFreePlan ? !hasPaidPlan : hasPaidPlan;

    function onButtonClick() {
        if (language === "da") {
            window.open("https://www.dotlegal.com/da/produkt/demo/book-en-demo", "_blank");
        } else {
            window.open("https://www.dotlegal.com/en/product/get-a-demo/book-a-demo", "_blank");
        }
    }

    return (
        shouldShow &&
        !isLoading && (
            <DotLegalButton onClick={() => onButtonClick()} buttonType={props.buttonType} btnLength={props.width}>
                {translateString("bookDemo")}
            </DotLegalButton>
        )
    );
}

export default BookDemoButton;
